var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0007 4.66634V2.66634C12.0007 1.93301 11.4007 1.33301 10.6673 1.33301H5.33398C4.60065 1.33301 4.00065 1.93301 4.00065 2.66634V4.66634H3.33398V8.66634L5.33398 12.6663V14.6663H10.6673V12.6663L12.6673 8.66634V4.66634H12.0007ZM5.33399 2.66633H10.6673V4.66633H9.32732V3.33299H8.66065V4.66633H7.33399V3.33299H6.66732V4.66633H5.33399V2.66633ZM9.33393 12.353L11.3339 8.35302V5.99969H4.66726V8.35302L6.66726 12.353V13.333H9.33393V12.353Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.4efe9f770c5882b63911bb2fe7ea9e01.svg";
export { ForwardRef as ReactComponent };